import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import { ClientDto } from '../../services/api/sharedTypes/Client'
import { ContactDto } from '../../services/api/sharedTypes/Contact'
import { getEmptyContactPersonObject } from '../../utils/client-utils'
import ContactPerson from './ContactPerson'
import SmallPlusButton from '../common/SmallPlusButton'

interface ContactPersonsListProps {
    client: ClientDto
    onChange: (client: ClientDto) => void
}

const ContactPersonsList: React.FC<ContactPersonsListProps> = ({ client, onChange }: ContactPersonsListProps) => {
    const dispatch = useAppDispatch()

    const deleteContactPerson = (index: number) => {
        if (!client) return
        const newClient = { ...client }
        newClient.contacts.splice(index, 1)
        onChange(newClient)
        dispatch(displayMessage({ message: 'Kontaktní osoba smazána', type: 'success' }))
    }

    const addContactPerson = () => {
        if (!client) return
        const newContactPersons: ContactDto[] = [...(client?.contacts ?? null), getEmptyContactPersonObject()]
        onChange({ ...client, contacts: newContactPersons })
        dispatch(displayMessage({ message: 'Kontaktní osoba přidána', type: 'success' }))
    }

    const editContactPerson = (index: number, editedContactPerson: ContactDto) => {
        if (!client) return
        const newContactPersons: ContactDto[] = [...(client?.contacts ?? null)]
        newContactPersons[index - 1] = editedContactPerson
        onChange({ ...client, contacts: newContactPersons })
    }

    return (
        <Stack>
            <Stack direction='row' justifyContent='space-between' mb={3}>
                <Typography variant='h6' color='primary'>
                    Kontaktní osoba
                </Typography>
                <SmallPlusButton onClick={addContactPerson} extraSmall />
            </Stack>
            {!client.contacts?.length && 'žádné kontaktní osoby'}
            {client.contacts?.map((contactPerson: ContactDto, i: number) => (
                <ContactPerson
                    onDelete={deleteContactPerson}
                    onEdit={editContactPerson}
                    contactPerson={contactPerson}
                    key={i}
                    id={i + 1}
                />
            ))}
        </Stack>
    )
}

export default ContactPersonsList
